export default __webpack_public_path__ + "static/media/bash-logo.bb723c54.jpg";